import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { IntegrationClienteModalComponent } from './integration-cliente-modal.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        IntegrationClienteModalComponent
    ],
    exports: [
        IntegrationClienteModalComponent
    ]
})
export class IntegrationClienteSharedModule { }
